import { gql } from "@apollo/client";

// api_gateway: Query.consultRequestAdmin (ConsultRequestAdminQuery, field ops, quyền PROJECT_CONSULT_*).
// Output là ConsultJSON = đúng JSON REST của fulfillment_be.

export const CONSULT_REQUEST_LIST = gql`
  query ConsultRequestList($filter: AdminConsultRequestFilter, $page: Int32, $size: Int32) {
    consultRequestAdmin {
      consultRequests(filter: $filter, page: $page, size: $size)
    }
  }
`;

export const CONSULT_REQUEST_STATUS_COUNTS = gql`
  query ConsultRequestStatusCounts($filter: AdminConsultRequestFilter) {
    consultRequestAdmin {
      statusCounts(filter: $filter)
    }
  }
`;

export const CONSULT_REQUEST_PROJECT_TYPE_OPTIONS = gql`
  query ConsultRequestProjectTypeOptions {
    consultRequestAdmin {
      projectTypeOptions
    }
  }
`;

export const CONSULT_REQUEST_DETAIL = gql`
  query ConsultRequestDetail($id: ID!) {
    consultRequestAdmin {
      consultRequest(id: $id)
    }
  }
`;

export const CONSULT_REQUEST_ASSIGNEES = gql`
  query ConsultRequestAssignees($keyword: String) {
    consultRequestAdmin {
      assignees(keyword: $keyword)
    }
  }
`;

export const CONSULT_REQUEST_NOTES = gql`
  query ConsultRequestNotes($id: ID!, $page: Int32, $size: Int32) {
    consultRequestAdmin {
      notes(id: $id, page: $page, size: $size)
    }
  }
`;

export const CONSULT_REQUEST_FILES = gql`
  query ConsultRequestFiles($id: ID!) {
    consultRequestAdmin {
      files(id: $id)
    }
  }
`;

export const CONSULT_REQUEST_DOWNLOAD_FILE = gql`
  query ConsultRequestDownloadFile($id: ID!, $fileId: ID!) {
    consultRequestAdmin {
      downloadFile(id: $id, fileId: $fileId) {
        id
        fileName
        contentType
        content
      }
    }
  }
`;

export const CONSULT_REQUEST_HISTORIES = gql`
  query ConsultRequestHistories($id: ID!, $action: String, $page: Int32, $size: Int32) {
    consultRequestAdmin {
      histories(id: $id, action: $action, page: $page, size: $size)
    }
  }
`;
